var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home d-flex"},[_c('Sidebar'),_c('router-view'),_c('Error'),_c('Success')],1)}
var staticRenderFns = []

export { render, staticRenderFns }